import { BreadCrumbItemViewModel } from "./viewModel"
import Link from "next/link"
import styles from "./index.module.scss"
import { CREATOR_MYPAGE_ITEM } from "./constants"

type Props = {
  items: BreadCrumbItemViewModel[]
}

export const CreatorMypageBreadCrumbs: React.FC<Props> = ({ items }) => {
  return (
    <nav className={styles.BreadCrumbs}>
      <li className={styles.BreadCrumbsItem}>
        <Link href={CREATOR_MYPAGE_ITEM.linkUrl as string}>
          <a className={styles.BreadCrumbsItem_anchor}>
            {CREATOR_MYPAGE_ITEM.label}
          </a>
        </Link>
      </li>
      {items.map((item, idx) => (
        <li className={styles.BreadCrumbsItem} key={idx}>
          {item.linkUrl ? (
            <Link href={item.linkUrl}>
              <a className={styles.BreadCrumbsItem_anchor}>{item.label}</a>
            </Link>
          ) : (
            <span>{item.label}</span>
          )}
        </li>
      ))}
    </nav>
  )
}
